import ShuffleText from "shuffle-text";

export default class Shuffle {
    constructor() {
        this.isSp = true;

        this.init();
    }

    init() {
        this._setBp();
    }

    _setBp() {
        const mediaQuery = window.matchMedia("(max-width: 1019px)");
        // イベントリスナーを登録

        mediaQuery.addListener((e) => {
            this._handleTabletChange(e);
        });

        this._handleTabletChange(mediaQuery);
    }

    _handleTabletChange(e) {
        if (e.matches) {
            this.isSp = true;
            this.shuffleTextSp();
        } else {
            this.isSp = false;
            this.shuffleTextPc();
        }
    }

    shuffleTextPc() {
        var shuffleList = [];
        const shuffletgt = [...document.querySelectorAll(".js-shuffletxt")];

        var duration = 300; // シャッフルエフェクトの期間を1000ミリ秒（1秒）に設定

        shuffletgt.forEach((shuffleText, i) => {
            // インスタンスを生成
            var shuffleInstance = new ShuffleText(shuffleText);

            shuffleInstance.duration = duration;

            // shuffleListに追加
            shuffleList[i] = shuffleInstance;

            window.addEventListener("load", () => {
                shuffleList[i].start();
            });
        });
    }

    shuffleTextSp() {
        var shuffleList = [];
        const shuffletgt = [...document.querySelectorAll(".js-shuffletxt")];
        
        var duration = 300; // シャッフルエフェクトの期間を1000ミリ秒（1秒）に設定

        shuffletgt.forEach(function (shuffleText, i) {
            // インスタンスを生成
            var shuffleInstance = new ShuffleText(shuffleText);

            // durationプロパティを設定
            shuffleInstance.duration = duration;

            // shuffleListに追加
            shuffleList[i] = shuffleInstance;
        });

        function setToggleClassOnceFunc() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio > 0) {
                        // 関連するShuffleTextインスタンスを開始
                        var index = shuffletgt.indexOf(entry.target);
                        entry.target.classList.add("-active");
                        
                        if (index !== -1) {
                            shuffleList[index].start();
                        }

                        observer.unobserve(entry.target);
                    }
                });
            });

            shuffletgt.forEach(($target) => {
                observer.observe($target);
            });
        }

        setToggleClassOnceFunc();
    }
}
